import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { json2formdata } from '../../core/helpers/jsontoformdata';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService extends ApiService {
    verifyPayment(id: string) {
      this.updateUrlExtention();
      return this.http.get(this.baseUrl + `backoffice${this.urlExtenssion}/verifyPayment?charge_id=${id}`);
    }

}
